module.exports = __webpack_public_path__ + "img/ad1x.daab415f.png";